<script>
    // based on suggestions from:
    // Inclusive Components by Heydon Pickering https://inclusive-components.design/collapsible-sections/
    export let headerText;
    let expanded = false
</script>

<div class="collapsible">
    <div class ="header">
        {headerText}
        <button aria-expanded={expanded} on:click={() => expanded = !expanded}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                <path class="open" d="M20 12L12 22L4 12" stroke="white" stroke-width="4" />
                <path class="close" d="M20 12L12 2L4 12" stroke="white" stroke-width="4" />
            </svg>
        </button>
    </div>
    <div class='contents' hidden={!expanded}>
        <slot></slot>
    </div>
</div>

<style>
    .header{
        display:flex;
        align-items: first baseline;
    }
   
    button[aria-expanded="true"] .open {
        display: none;
    }

    button[aria-expanded="false"] .close {
        display: none;
    }

    button{
        background-color: transparent;
        border: none;
    }
    svg {
        height: 10px;
	    width: 10px;
    }
</style>